import React from 'react';

const VARIANTS = {
  nav: {
    badge: 'h-11 rounded-[14px] border border-white/10 shadow-[0_12px_24px_rgba(2,8,23,0.16)]',
    gap: 'gap-3',
    text: 'text-[1.45rem]',
    showWordmark: true,
  },
  sidebar: {
    badge: 'h-12 rounded-[14px] border border-white/10 shadow-[0_14px_28px_rgba(2,8,23,0.18)]',
    gap: 'gap-3',
    text: 'text-[1.4rem]',
    showWordmark: true,
  },
  footer: {
    badge: 'h-10 rounded-[12px] border border-white/10 shadow-[0_10px_20px_rgba(2,8,23,0.15)]',
    gap: 'gap-2.5',
    text: 'text-[1.1rem]',
    showWordmark: true,
  },
  card: {
    badge: 'h-12 rounded-[14px] border border-white/10 shadow-[0_14px_28px_rgba(2,8,23,0.18)]',
    gap: 'gap-3',
    text: 'text-[1.35rem]',
    showWordmark: false,
  },
};

export default function BrandLogo({ variant = 'nav', className = '' }) {
  const selected = VARIANTS[variant] || VARIANTS.nav;

  return (
    <div className={`inline-flex items-center ${selected.gap} ${className}`}>
      <div className={`inline-flex overflow-hidden bg-[#071120] ${selected.badge}`}>
        <img
          src="/ctiq.png"
          alt="ComplyTradeIQ"
          className="block h-full w-auto max-w-none"
        />
      </div>
      {selected.showWordmark ? (
        <div
          className={`font-display leading-none tracking-[-0.03em] whitespace-nowrap text-white/95 ${selected.text}`}
        >
          <span>ComplyTrade</span>
          <span className="text-cyan-400">IQ</span>
        </div>
      ) : null}
    </div>
  );
}
